import React, { useState, useEffect } from 'react';

// import imageSuccess from '../../img/success.svg';

export const StepConfirm = () => {

    return <div className="m-form__step m-form__step--confirm">
        <div className="m-form__container">
            <div className="m-form__icon"></div>
            <h2 className="m-form__header">Dziękujemy za potwierdzenie złożenia wniosku</h2>
            <p className="m-form__content">
            Skontaktujemy się z Państwem drogą mailową, bądź telefonicznie.
            </p>
        </div>
    </div>
}

